import React from 'react';
import { Button } from 'rsuite';
import { CleanDeliveryOrder } from '../../../../export-types/cleaned-types';
import useSWR from 'swr';
import { fetcher } from '../../../../services/api';
import { ModalsService } from '../../../../services/modals.service';
import { SentToRecipientModal } from './sent-to-recipient-modal';

type Props = {
  id: string;
};
export const RecipientInfoButton: React.FC<Props> = (props) => {
  const { data: order, isLoading } = useSWR<CleanDeliveryOrder>(
    `/delivery-order/${props.id}`,
    fetcher,
  );
  if (isLoading || !order || !order.address) {
    return null;
  }
  return (
    <>
      <Button
        className={'btn btn-outline-secondary align-items-center d-flex'}
        onClick={async () => {
          await ModalsService.createModal(SentToRecipientModal, {
            orderId: order.id,
            readOnly: true,
          });
        }}
      >
        Добавить описание
      </Button>
    </>
  );
};
